var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#B3C8E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0254 10.6238C29.1201 10.5291 29.2832 10.5291 29.3779 10.6238C29.4725 10.7185 29.4725 10.8816 29.3779 10.9763L21.1777 19.1765C21.1265 19.2277 21.0655 19.2498 21.001 19.2498C20.9367 19.2497 20.8763 19.2276 20.8252 19.1765C20.7305 19.0818 20.7306 18.9187 20.8252 18.824L29.0254 10.6238Z",
    fill: "#0B4F9F",
    stroke: "#0B4F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9992 15.55C29.5892 15.55 29.2492 15.21 29.2492 14.8V10.75H25.1992C24.7892 10.75 24.4492 10.41 24.4492 10C24.4492 9.59 24.7892 9.25 25.1992 9.25H29.9992C30.4092 9.25 30.7492 9.59 30.7492 10V14.8C30.7492 15.21 30.4092 15.55 29.9992 15.55Z",
    fill: "#0B4F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30.75H17C11.57 30.75 9.25 28.43 9.25 23V17C9.25 11.57 11.57 9.25 17 9.25H19C19.41 9.25 19.75 9.59 19.75 10C19.75 10.41 19.41 10.75 19 10.75H17C12.39 10.75 10.75 12.39 10.75 17V23C10.75 27.61 12.39 29.25 17 29.25H23C27.61 29.25 29.25 27.61 29.25 23V21C29.25 20.59 29.59 20.25 30 20.25C30.41 20.25 30.75 20.59 30.75 21V23C30.75 28.43 28.43 30.75 23 30.75Z",
    fill: "#0B4F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalIcon);
export default __webpack_public_path__ + "static/media/external-icon.3b5d5eea2c48d6b89e13b1cbebd8164e.svg";
export { ForwardRef as ReactComponent };